export const up = (pageContent) => {
    const hasLockedValue = Object.keys(pageContent).includes('isLocked');
    if (!hasLockedValue) {
        pageContent.isLocked = false;
    }
    
    return pageContent;
}